import { useBuildingAggregates } from "./hooks/useBuildingAggregates";
import { IconContext } from "react-icons";
import { PiBuildingsFill, PiBroadcastFill } from "react-icons/pi";
import { IoNotifications, IoCloudDone } from "react-icons/io5";
import { LuPowerOff } from "react-icons/lu";
import "./tableStyle.scss";

/**
 * Portfolio KPI band (Properties / Sensors / Online / Alerts / Shutdowns) shown
 * at the top of the dashboard, above the needs-attention feed. Reuses
 * `useBuildingAggregates`, which React Query dedupes by queryKey, so this shares
 * the same data as the feed and table with no extra requests.
 *
 * Kept as .js (like buildingEventsTable) because react-icons trips TS2786 under
 * the current @types/react when used in .tsx.
 */
export default function PortfolioKpis({ buildings, startDate, endDate }) {
  const { totals } = useBuildingAggregates(buildings, startDate, endDate);

  if (!buildings || !buildings.length) return null;

  return (
    <div className="container-infobox">
      <div className="info-textbox">
        <IconContext.Provider value={{ color: "#BBDA62", className: "icon" }}>
          <PiBuildingsFill className="icon" />
        </IconContext.Provider>
        <div className="info-textbox-body">
          <span>{totals.properties}</span>
          <h2>Properties</h2>
        </div>
      </div>
      <div className="info-textbox">
        <IconContext.Provider value={{ color: "#A4A4A4", className: "icon" }}>
          <PiBroadcastFill className="icon" />
        </IconContext.Provider>
        <div className="info-textbox-body">
          <span>{totals.units}</span>
          <h2>Sensors</h2>
        </div>
      </div>
      <div className="info-textbox">
        <IconContext.Provider value={{ color: "#0D47A1", className: "icon" }}>
          <IoCloudDone className="icon" />
        </IconContext.Provider>
        <div className="info-textbox-body">
          <span>
            {totals.onlineSensors} / {totals.units}
          </span>
          <h2>Sensors online</h2>
        </div>
      </div>
      <div className="info-textbox">
        <IconContext.Provider value={{ color: "#E74C3C", className: "icon" }}>
          <IoNotifications className="icon" />
        </IconContext.Provider>
        <div className="info-textbox-body">
          <span>{totals.alerts}</span>
          <h2>Alerts</h2>
        </div>
      </div>
      <div className="info-textbox">
        <IconContext.Provider value={{ color: "#1976D2", className: "icon" }}>
          <LuPowerOff className="icon" />
        </IconContext.Provider>
        <div className="info-textbox-body">
          <span>{totals.pcoEquipped > 0 ? totals.shutdowns : "N/A"}</span>
          <h2>Safety shut offs</h2>
        </div>
      </div>
    </div>
  );
}
